import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, CheckPermission, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { DeleteLocationApi, LocationApi, QRExport, ModuleApi } from "../../api";
import { Link } from 'react-router-dom'
import moment from "jalali-moment";


export const Location = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const [tableKeeperData, setTableKeeperData] = useState<any>([])
    const [detailModule, setDetailModule] = useState<any>(null)
    const [col, setCol] = useState<any>([
        {
            title: "نام موقعیت مکانی ",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.name && i.name != null && i.name}</div>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "کد QR",
            render: (i: any) => (<>{i.code && i.code != null && <img src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${i.code}`} className="h-[70px] w-[70px] mr-5" />}</>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-center ">
                    <img onClick={() => downloadQR(i.id)} src="/assetes/svg/download.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                    <img onClick={() => prictQR(i.id)} src="/assetes/svg/print.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                    {CheckPermission(33) &&
                        <Link to={`/p/location/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(34) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] mx-[7px] cursor-pointer" />
                    }
                </div>)
        },

    ])

    const getModuleData = async () => {
        try {
            let res = await ModuleApi()
            let tableCol = [...col]
            if (res?.data?.modules != null && Array.isArray(res?.data?.modules)) {
                for (let j of res.data.modules) {
                    if (j.id == 2 && detailModule == null) {
                        setDetailModule(j)
                        tableCol.splice(3, 0, {
                            title: "لینک اختصاصی",
                            render: (i: any) => (
                                <>
                                    {j?.company_has_this_module == true && j?.company_expire_date_for_this_moule != null &&
                                        <>
                                            {new Date(j?.company_expire_date_for_this_moule).getTime() >= new Date(moment().locale('fa').format('YYYY/M/D')).getTime() &&
                                                <button onClick={() => handelCopySlug(i.slug)} className='m-1 flex items-center h-[35px] justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px] m-auto'>کپی کردن لینک</button>
                                            }
                                            {new Date(j?.company_expire_date_for_this_moule).getTime() < new Date(moment().locale('fa').format('YYYY/M/D')).getTime() &&
                                                <Link to='/p/module'>
                                                    <button  className='m-1 flex items-center h-[35px] justify-center text-white text-[10px] bg-black rounded-[8px] px-[8px] py-[4px] m-auto'> افزونه منقضی است</button>
                                                </Link>
                                            }
                                        </>
                                    }
                                    {j?.company_has_this_module == false &&
                                        <Link to='/p/module'>
                                            <button className='m-1 flex items-center h-[35px] justify-center text-dayan-gray-200 text-[10px] bg-gray-100 rounded-[8px] px-[8px] py-[4px] m-auto'> ماژول غیر فعال</button>
                                        </Link>
                                    }
                                </>
                            )
                        })
                    }
                }
            }
            setCol(tableCol)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }


    const searchManual = (value: any) => {
        setTableData(
            tableKeeperData.filter((value1: any) => {
                return !!(value1.name.toUpperCase().includes(value.toUpperCase()));
            })
        )
    }

    const handelCopySlug = (slug: string) => {
        navigator.clipboard.writeText(`https://app.dayan.app?qr=${slug}`)
        toast("کپی شد", { type: "success" })
    }

    const prictQR = async (id: any) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await QRExport(id)
        CtxLoad.setDisplayLoadingBlur(false)
        var printWindow: any = window.open('', '');
        printWindow.document.write('<html><head><title></title>');
        printWindow.document.write('</head><body ><img src=\'');
        printWindow.document.write(res);
        printWindow.document.write('\' /></body></html>');
        printWindow.document.close();
        printWindow.print();
        printWindow.close()
    }

    const downloadQR = async (id: any) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await QRExport(id)
        CtxLoad.setDisplayLoadingBlur(false)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", 'qr_code');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteLocationApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }


    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await LocationApi()
            setTableData(res.data)
            setTableKeeperData(res.data)
            // CtxLoad.setDisplayLoadingSkelton(false)
            getModuleData()
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "موقعیت های مکانی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 5, 'subItem': 0, })
        getData()
    }, [])

    return (
        <div className=" w-full flex flex-col">

            <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت موقعیت‌های مکانی</h1>
            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className="w-full md:w-[49%] flex flex-wrap items-center justify-between">
                    {CheckPermission(32) &&
                        <>
                            <div className=" w-full md:w-[49%] w-full pl-2 overflow-hidden flex items-center bg-white md:mb-0 mb-2 h-[40px] md:h-[50px] rounded-md border-0 shadow">
                                <input type={'text'} onChange={(e) => searchManual(e.target.value)} placeholder="جستجو مکان" className=" w-[calc(100%-30px)] h-full text-sm px-3 focus:outline-none" />
                                <div className=" w-[30px] h-[30px]  flex justify-center items-center">

                                    <svg x="0px" y="0px" viewBox="0 0 487.95 487.95" className={`  w-[25px] fill-[#b9b2b2] `}>
                                        <use xlinkHref="/assetes/svg/search.svg#search" />
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div className=" w-full md:w-[50%] flex items-center justify-end md:mt-0 mt-[7px]">
                    {CheckPermission(31) ?
                        <button className=" w-full md:w-fit sm:px-[40px] px-[10px] h-[35px] md:h-[45px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/location/add' className=" w-full h-full flex justify-center items-center">
                                + ایجاد موقعیت مکانی
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(32) &&
                <div className=" w-full ">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
